import angular from 'angular';

angular
  .module('home', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('home', {
        url: '/home',
        controller: 'HomeCtrl',
        controllerAs: 'home',
        templateUrl: require('./home.html'),
        data: {
          authorizedRole: 'USER_BO'
        }
      });
    }
  ]);
